module.exports = __webpack_public_path__ + "img/sentiment_blog.667568fb.svg";